export default __webpack_public_path__ + "static/media/logo.084f4b54.png";